import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import AlertMessage from './AlertMessage';
import Memo from './Memo';
import Modal from 'react-modal';
import PlusInput from './PlusInput';
import Plus2Input from './Plus2Input';
import FomulaInput from './FomulaInput';
import SelectionInput from './SelectionInput';
import NumberInputRow  from './NumberInputRow';
import NumberOrTimeInputRow  from './NumberOrTimeInputRow';
import Minus6Input  from './Minus6Input';
import HyojunhoshuInput  from './HyojunhoshuInput';
import {removeCommas, sanitizeInputValue, calculatePlusFromPlusS, containingArithmeticOperation, convertAutomatically, valuePresent, findChanges, splitAmountAndWage, timeToFloat} from './utilities';
import { isDeductionOnlyItem, findMatchedKeyword } from './deductionOnlyItems';

class CompanyPayrollsTable extends React.Component {
  constructor(props) {
    super(props);
    const prop_payroll = JSON.parse(JSON.stringify(this.props.payroll));

    // #2110: IME(日本語入力)がONのまま数値入力したとき、1回の変換につき1度だけ
    // 警告トーストを出すためのフラグ。compositionが終わると false に戻す。
    this._imeToastShown = false;

    this.state = {
      user_payrolls: [],
      loading: false,
      saving: false,
      load_more: false,
      showProgressPopup: false,
      page: 0,
      tax2024: this.props.tax2024,
      waggerTimerDisplay: prop_payroll.puPlus2Texts.map(() => false),
      puPlusEditDisplay: prop_payroll.puPlus2Texts.map(() => false),
      puMinusEditDisplay: prop_payroll.puMinus6Texts.map(() => false),
      puPlus0Display: false,
      puPlus1Display: false,
      puPlus2Display: false,
      alertPopup: {
        isShow: false,
        type: 'success',
        message: ''
      },
      memoPopup: {
        isShow: false,
        message: null,
        userName: null,
        cell: null
      },
      typingTimeout: 0,
      savingProgress: 0,
      payroll: prop_payroll,
      touched: [],
      isModalOpen: false,
      redirect_url: '',
      manual_mode: this.props.manual_mode == 'manual' ? true : false,
      rtaxChangedUsers: [],
      isTimeFormat: this.props.time_format,
      nameLengthErrors: { plus: [], minus: [] },
      deductionWarnings: [],
      // #2133: メモを下部ドック + スライドドロワーで開閉する。
      memoDrawerOpen: false
    };
    this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
    this.nameLengthToast = null;
    this.deductionWarningToast = null;
  }

  componentDidMount() {
    this.setState({
      loading: true,
      page: this.state.page + 1,
      deductionWarnings: this.validateDeductionOnlyItems(this.state.payroll)
    }, () => {
      this.loadMoreUserPayrolls().then(res => {
        this.setWaggerTimeDisplay();
        this.setPuDisplay();
        this.updateAllowancesAndDeductionsNumber();
      });
      this.setNotAutoCalcHealthInsurance();
    });
  }

  componentWillUnmount() {
    this.removeBeforeUnloadListener();
    if (this.nameLengthToast) {
      this.nameLengthToast.remove();
      this.nameLengthToast = null;
    }
    if (this.deductionWarningToast) {
      this.deductionWarningToast.remove();
      this.deductionWarningToast = null;
    }
  }

  handleBeforeUnload(event) {
    if (this.state.touched.length > 0) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  addBeforeUnloadListener() {
    if (this.state.touched.length > 0) {
      window.addEventListener('beforeunload', this.handleBeforeUnload);
    }
  }

  removeBeforeUnloadListener() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  componentDidUpdate(prevProps, prevState) {
    this.removeBeforeUnloadListener();
    this.addBeforeUnloadListener();

    if (this.state.user_payrolls.length !== prevState.user_payrolls.length) {
      this.setWaggerTimeDisplay();
      this.setPuDisplay();
    }
    this.setNotAutoCalcHealthInsurance();
  }

  setNotAutoCalcHealthInsurance = () => {
    const { user_payrolls } = this.state;

    if (user_payrolls.length > 0) {
      user_payrolls.forEach((up, idx) => {
        if (up.puShakaiHoken !== 'social_insurance_auto' && up.puNenkinHoken !== 'welfare_pension_auto' && up.puHyojunHoshu !== 0) {
          this.automaticCalculatePayroll(0, idx, 'puHyojunHoshu');
        }
      });
    }
  };

  loadMoreUserPayrolls = () => {
    const {
      company,
      paramID
    } = this.props;
    const {
      page,
      user_payrolls
    } = this.state;

    return new Promise((resolve, reject) => {
      axios.get(`/companies/${company.cID}/payrolls/${paramID}/fetch_user_payrolls?p=${page}`).then(({
        data
      }) => {
        const data_user_payrolls = data.user_payrolls.reduce((acc, obj) => {
          const newObj = Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [key, convertAutomatically(value, key)])
          );

          return [...acc, {...newObj, id: newObj.puID}];
        }, []);

        this.setState({
          user_payrolls: [...user_payrolls, ...data_user_payrolls],
          loading: false,
          load_more: data.load_more,
          page: page + 1
        }, () => {
          if (this.state.user_payrolls.length === 0) {
            window.location.href = '/';
          }
          if(data.load_more) this.loadMoreUserPayrolls();
          resolve(data);
        });
      });
    });
  };

  setWaggerTimeDisplay = () => {
    const {
      user_payrolls,
      waggerTimerDisplay
    } = this.state;

    const waggerTimerDisplayTmp = [...waggerTimerDisplay];

    user_payrolls.forEach(up => {
      up.puPlus2Texts.forEach((p2Text, idx) => {
        if (containingArithmeticOperation(p2Text)) {
          waggerTimerDisplayTmp[idx] = true;
        }
      });
    });

    this.setState({
      waggerTimerDisplay: waggerTimerDisplayTmp
    });
  };

  toggleDisplay = (type, index) => {
    this.setState(prevState => {
      const updatedDisplay = [...prevState[type]];

      updatedDisplay[index] = !updatedDisplay[index];

      return { [type]: updatedDisplay };
    });
  };

  openModal = (redirect_url) => {
    this.setState({
      isModalOpen: true,
      redirect_url: redirect_url
    });
  };

  closeModal = () => {
    const {
      redirect_url
    } = this.state;

    this.setState({
      isModalOpen: false
    });
    window.location.replace(redirect_url);
  };

  validateNameLengths = (payroll) => {
    const maxLen = this.props.maxNameLength || 30;
    const trimRegex = /^[\s\u3000]+|[\s\u3000]+$/g;
    const plusErrors = [];
    const minusErrors = [];

    payroll.puPlus2Texts.forEach((text, idx) => {
      if (text && text.replace(trimRegex, '').length > maxLen) {
        plusErrors.push(idx);
      }
    });
    payroll.puMinus6Texts.forEach((text, idx) => {
      if (text && text.replace(trimRegex, '').length > maxLen) {
        minusErrors.push(idx);
      }
    });

    const hasErrors = plusErrors.length > 0 || minusErrors.length > 0;

    if (hasErrors) {
      if (!this.nameLengthToast) {
        this.nameLengthToast = document.createElement('div');
        this.nameLengthToast.className = 'name-length-toast';
        this.nameLengthToast.textContent = `項目名は${maxLen}文字以内にしてください`;
        document.body.appendChild(this.nameLengthToast);
      }
    } else if (this.nameLengthToast) {
      this.nameLengthToast.remove();
      this.nameLengthToast = null;
    }

    return { plus: plusErrors, minus: minusErrors };
  };

  // 金額が1人でも入っているのに項目名が空の行。0 と空欄は金額なしとみなす。
  missingNameIndexes = (names, key) => {
    const trimRegex = /^[\s\u3000]+|[\s\u3000]+$/g;

    return names.reduce((idxs, name, idx) => {
      if ((name || '').replace(trimRegex, '') !== '') return idxs;

      return this.hasAmountAt(key, idx) ? [...idxs, idx] : idxs;
    }, []);
  };

  missingNames = () => {
    const { payroll } = this.state;

    return {
      plus: this.missingNameIndexes(payroll.puPlus2Texts, 'puPlus2Texts'),
      minus: this.missingNameIndexes(payroll.puMinus6Texts, 'puMinus6Texts')
    };
  };

  validateDeductionOnlyItems = (payroll) => {
    const warnings = [];
    payroll.puPlus2Texts.forEach((text, idx) => {
      if (isDeductionOnlyItem(text)) {
        warnings.push(idx);
      }
    });

    if (warnings.length > 0) {
      const matchedKeyword = payroll.puPlus2Texts
        .filter((_, idx) => warnings.includes(idx))
        .map((text) => findMatchedKeyword(text))
        .find((k) => k);
      if (!this.deductionWarningToast) {
        this.deductionWarningToast = document.createElement("div");
        this.deductionWarningToast.className = "deduction-warning-toast";
        document.body.appendChild(this.deductionWarningToast);
      }
      this.deductionWarningToast.textContent =
        `「${matchedKeyword}」は支給項目ではなく控除項目に設定してください。支給項目に設定すると雇用保険・所得税の計算に影響します。`;
    } else if (this.deductionWarningToast) {
      this.deductionWarningToast.remove();
      this.deductionWarningToast = null;
    }

    return warnings;
  };

  handlePayrollChange = (value, key, idx = null) => {
    const payroll_tmp = JSON.parse(JSON.stringify(this.state.payroll));

    if (key === 'puPlus2Texts') payroll_tmp['puPlus2Texts'][idx] = value;
    if (key === 'puMinus6Texts') payroll_tmp['puMinus6Texts'][idx] = value;
    if (key === 'payName') {
      payroll_tmp['payName'] = value;
      payroll_tmp['name'] = value;
    }

    const updatedPayroll = payroll_tmp;

    this.setState({
      payroll: updatedPayroll,
      nameLengthErrors: this.validateNameLengths(updatedPayroll),
      deductionWarnings: this.validateDeductionOnlyItems(updatedPayroll)
    }, () => this.updateAllowancesAndDeductionsNumber());
  };

  updateAllowancesAndDeductionsNumber = () => {
    const {
      payroll
    } = this.state;
    let puPlus2Texts = payroll['puPlus2Texts'];
    let puMinus6Texts = payroll['puMinus6Texts'];

    if (this.props.isPaidOrTrialPlan) {
      // Paid / trial plan: unlimited rows. Keep exactly one trailing empty row.
      if(puPlus2Texts[puPlus2Texts.length - 1] !== '') puPlus2Texts.push('');

      if(puMinus6Texts[puMinus6Texts.length - 1] !== '') puMinus6Texts.push('');

      if(puPlus2Texts[puPlus2Texts.length - 2] == '' && puPlus2Texts.length > 5
        && !this.hasAmountAt('puPlus2Texts', puPlus2Texts.length - 1)) puPlus2Texts.pop();

      if(puMinus6Texts[puMinus6Texts.length - 2] == '' && puMinus6Texts.length > 5
        && !this.hasAmountAt('puMinus6Texts', puMinus6Texts.length - 1)) puMinus6Texts.pop();
    } else {
      puPlus2Texts = this.capFreePlanRows(puPlus2Texts, 'puPlus2Texts', this.props.maxAllowances);
      puMinus6Texts = this.capFreePlanRows(puMinus6Texts, 'puMinus6Texts', this.props.maxDeductions);
    }

    this.setState({
      payroll: {
        ...this.state.payroll,
        puPlus2Texts: puPlus2Texts,
        puMinus6Texts: puMinus6Texts,
        pPayPlusCount: puPlus2Texts.length,
        pPayMinusCount: puMinus6Texts.length
      },
      // #655: keep each user_payroll's parallel allowance arrays the same length
      // as the item-name array so brand-new rows can use 単価×時/日 immediately.
      user_payrolls: this.syncUserPayrollAllowanceColumns(puPlus2Texts.length)
    });
  };

  // Free plan: no new rows beyond the plan limit. Existing named rows and rows holding amounts are kept.
  capFreePlanRows = (texts, key, maxRows) => {
    let rows = [...texts];

    while (rows.length > maxRows && rows[rows.length - 1] === ''
      && !this.hasAmountAt(key, rows.length - 1)) {
      rows.pop();
    }

    if (rows.length < maxRows && rows[rows.length - 1] !== '') {
      rows = [...rows, ''];
    }

    return rows;
  };

  hasAmountAt = (key, idx) => this.state.user_payrolls.some((up) => {
    const amount = calculatePlusFromPlusS(up[key]?.[idx]);
    return Number.isFinite(amount) && amount !== 0;
  });

  // Keep each user_payroll's allowance arrays (puPlus2Texts / puPlus2WageTexts /
  // puPlus2AmountTexts) the same length as the item-name array so brand-new rows
  // can use 単価×時/日 immediately, without saving and re-editing. The backend
  // (jsx_support.rb) only computes these arrays after save, so we initialize the
  // parallel entries here with empty strings to mirror a saved row's structure.
  syncUserPayrollAllowanceColumns = (length) => {
    return this.state.user_payrolls.map((up) => {
      const synced = { ...up };

      // Only ever extend (never truncate) so saved allowance data is preserved;
      // brand-new trailing rows just gain empty-string entries.
      ['puPlus2Texts', 'puPlus2WageTexts', 'puPlus2AmountTexts'].forEach((key) => {
        const arr = Array.isArray(synced[key]) ? [...synced[key]] : [];

        while (arr.length < length) arr.push('');
        synced[key] = arr;
      });

      return synced;
    });
  };

  setPuDisplay = () => {
    const {
      user_payrolls
    } = this.state;

    if (user_payrolls.length > 0) {
      user_payrolls.forEach((up) => {
        if (containingArithmeticOperation(up.puPlus0s)) {
          this.setState({
            puPlus0Display: true
          });
        }
        if (containingArithmeticOperation(up.puPlus1s)) {
          this.setState({
            puPlus1Display: true
          });
        }
        if (containingArithmeticOperation(up.puPlus3s)) {
          this.setState({
            puPlus3Display: true
          });
        }
      });
    }
  };

  setValueChanged = (changes, new_user_payrolls = []) => {
    this.setState({
      touched: this.mergeTouched(changes),
      user_payrolls: new_user_payrolls.length > 0 ? [...new_user_payrolls] : this.state.user_payrolls,
    });
  };

  toggleMessage = (message, type) => {
    this.setState({
      alertPopup: {
        isShow: true,
        message: message,
        type: type,
        stamp: Date.now()
      }
    });
  };

  toggleMemo = (uID, cell) => {
    const user_payroll = this.state.user_payrolls.find(i => i.uID === uID);

    if(user_payroll.puMemo && user_payroll.puMemo !== '') {
      this.setState({
        memoPopup: {
          isShow: true,
          message: user_payroll.puMemo,
          userName: user_payroll.user.uName,
          cell: cell
        }
      });
    } else {
      this.setState({
        memoPopup: {
          isShow: false
        }
      });
    }
  };

  removeUserPayroll = (user) => {
    const {
      company,
      paramID
    } = this.props;
    const {
      user_payrolls
    } = this.state;

    if (!confirm(`${user.uName}さんをこの一覧から削除してもよろしいですか?`)) return;

    axios
      .delete(`/companies/${company.cID}/payrolls/${paramID}/users/${user.uID}`)
      .then(({
        data
      }) => {
        this.setState({
          user_payrolls: user_payrolls.filter(item => item.uID !== user.uID)
        }, () => {
          if (this.state.user_payrolls.length === 0) {
            window.location.href = '/';
          }
          this.toggleMessage(data.message, 'success');
        });

      })
      .catch((error) => this.toggleMessage(error.response?.data?.error || error.message, 'error'));
  };

  clearData = (key, index_key = null) => {
    const user_payrolls = this.state.user_payrolls;
    const user_payrolls_tmp = JSON.parse(JSON.stringify(this.state.user_payrolls));
    let changes = [];

    user_payrolls_tmp.map((up, index) => {
      switch (key) {
      case 'puPlus0Amount': {
        up[key] = '';
        (up['puPlus0Wage'] === '' && up[key] === '') ? up['puPlus0s'] = '' : up['puPlus0s'] = `${up['puPlus0Wage']}*0`;
        break;
      }
      case 'puPlus1Amount': {
        up[key] = '';
        (up['puPlus1Wage'] === '' && up[key] === '') ? up['puPlus1s'] = '' : up['puPlus1s'] = `${up['puPlus1Wage']}*0`;
        break;
      }
      case 'puPlus3Amount': {
        up[key] = '';
        (up['puPlus3Wage'] === '' && up[key] === '') ? up['puPlus3s'] = '' : up['puPlus3s'] = `${up['puPlus3Wage']}*0`;
        break;
      }
      case 'puPlus2AmountTexts': {
        up[key][index_key] = '';
        (up['puPlus2WageTexts'][index_key] === '' && up[key][index_key] === '') ? up['puPlus2Texts'][index_key] = '' : up['puPlus2Texts'][index_key] = `${up['puPlus2WageTexts'][index_key]}*0`;
        break;
      }
      case 'puPlus2Texts': {
        up['puPlus2Texts'][index_key] = '';
        up['puPlus2WageTexts'][index_key] = '';
        up['puPlus2AmountTexts'][index_key] = '';
        break;
      }
      case 'puMinus6Texts': {
        up['puMinus6Texts'][index_key] = '';
        break;
      }
      // Work hours fields - set to null
      case 'work_days':
      case 'work_hours':
      case 'work_overtime_hours':
      case 'work_night_hours':
      case 'work_holiday_hours': {
        up[key] = null;
        break;
      }
      default: break;
      }
      changes = [...changes, ...findChanges(up.uID, up, user_payrolls[index])];
    });

    // Work-hour fields are excluded from live recalculation (mirrors the
    // exclusion list in automaticCalculatePayroll). Clearing a 単価×数量 value
    // ('puPlus0/1/2/3Amount') must refresh 支給合計 in real time, so trigger the
    // backend auto-calc for every user payroll after the state is updated.
    const shouldRecalculate = ![
      'work_days', 'work_hours', 'work_overtime_hours', 'work_night_hours', 'work_holiday_hours'
    ].includes(key);

    this.setState({
      touched: this.mergeTouched(changes),
      user_payrolls: user_payrolls_tmp
    }, () => {
      if (shouldRecalculate) {
        user_payrolls_tmp.forEach((up, index) => this.triggerCallApi(index, up.uID));
      }
    });
  };

  // Build a '単価*数量' formula from a wage/amount pair, normalizing the empty
  // case so that clearing both fields with BS/Delete yields the same '' value as
  // the「ｘ」clear button (see clearData). Without this, BS-clearing produced
  // '0*0', which differs from「ｘ」and was inconsistently reflected on 保存.
  buildWageFormula = (wage, amount) => {
    const hasWage = wage !== undefined && wage !== null && wage !== '';
    const hasAmount = amount !== undefined && amount !== null && amount !== '';

    if (!hasWage && !hasAmount) return '';

    return `${hasWage ? wage : '0'}*${hasAmount ? amount : '0'}`;
  };

  mergeTouched = (changes) => {
    const touched_values = [];

    changes.forEach((item) => {
      if (!this.state.touched.some(t => t?.id === item?.id && t?.key === item?.key && t?.idx === item?.idx)) {
        touched_values.push(item);
      }
    });

    return [...this.state.touched, ...touched_values];
  };

  automaticCalculatePayroll = (value, index, key, index_key = null) => {
    const {user_payrolls} = this.state;
    const user_payrolls_tmp = JSON.parse(JSON.stringify(this.state.user_payrolls));

    value = removeCommas(value);
    value = convertAutomatically(value, key);
    switch (key) {
    case 'puPlus2Texts': {
      user_payrolls_tmp[index]['puPlus2Texts'][index_key] = value;
      const { wage, amount } = splitAmountAndWage(value);

      user_payrolls_tmp[index]['puPlus2AmountTexts'][index_key] = amount;
      user_payrolls_tmp[index]['puPlus2WageTexts'][index_key] = wage;
      const { waggerTimerDisplay } = this.state;

      if (containingArithmeticOperation(value)) {
        waggerTimerDisplay[index_key] = true;
      }
      this.setState({ waggerTimerDisplay: waggerTimerDisplay });
      break;
    }
    case 'puMinus6Texts': {
      value = sanitizeInputValue(value);
      user_payrolls_tmp[index]['puMinus6Texts'][index_key] = value;
      break;
    }
    case 'puPlus0s': {
      user_payrolls_tmp[index]['puPlus0s'] = value;
      user_payrolls_tmp[index]['puPlus0'] = calculatePlusFromPlusS(user_payrolls_tmp[index]['puPlus0s']);
      const { wage, amount } = splitAmountAndWage(value);

      user_payrolls_tmp[index]['puPlus0Amount'] = amount;
      user_payrolls_tmp[index]['puPlus0Wage'] = wage;
      if (containingArithmeticOperation(value)) {
        this.setState({ puPlus0Display: true });
      }
      break;
    }
    case 'puPlus1s': {
      user_payrolls_tmp[index]['puPlus1s'] = value;
      user_payrolls_tmp[index]['puPlus1'] = calculatePlusFromPlusS(user_payrolls_tmp[index]['puPlus1s']);
      const { wage, amount } = splitAmountAndWage(value);

      user_payrolls_tmp[index]['puPlus1Amount'] = amount;
      user_payrolls_tmp[index]['puPlus1Wage'] = wage;
      if (containingArithmeticOperation(value)) {
        this.setState({ puPlus1Display: true });
      }
      break;
    }
    case 'puPlus3s': {
      user_payrolls_tmp[index]['puPlus3s'] = value;
      user_payrolls_tmp[index]['puPlus3'] = calculatePlusFromPlusS(user_payrolls_tmp[index]['puPlus3s']);
      const {amount, wage} = splitAmountAndWage(value);

      user_payrolls_tmp[index]['puPlus3Amount'] = amount;
      user_payrolls_tmp[index]['puPlus3Wage'] = wage;
      if (containingArithmeticOperation(value)) {
        this.setState({ puPlus3Display: true });
      }
      break;
    }
    case 'puKubun': {
      user_payrolls_tmp[index]['puKubun'] = value;
      break;
    }
    case 'puShakaiHoken': {
      user_payrolls_tmp[index]['puShakaiHoken'] = value;
      if (value === 'social_insurance_manual') {
        if (user_payrolls_tmp[index]['puMinus1'].toString() != '0')
          user_payrolls_tmp[index]['puMinus1'] = '0';
        if (user_payrolls_tmp[index]['puMinus3'].toString() != '0')
          user_payrolls_tmp[index]['puMinus3'] = '0';
        if (user_payrolls_tmp[index]['childcare_support_fee'].toString() != '0')
          user_payrolls_tmp[index]['childcare_support_fee'] = '0';
      }
      break;
    }
    case 'puKoyoHoken': {
      user_payrolls_tmp[index]['puKoyoHoken'] = value;
      if (value === 'unemployment_insurance_manual') {
        if (user_payrolls_tmp[index]['puMinus4'].toString() != '0')
          user_payrolls_tmp[index]['puMinus4'] = '0';
      }
      break;
    }
    case 'puNenkinHoken': {
      user_payrolls_tmp[index]['puNenkinHoken'] = value;
      if (value === 'welfare_pension_manual') {
        if (user_payrolls_tmp[index]['puMinus2'].toString() != '0')
          user_payrolls_tmp[index]['puMinus2'] = '0';
      }
      break;
    }
    case 'puPlus2WageTexts': {
      user_payrolls_tmp[index]['puPlus2WageTexts'][index_key] = value;
      user_payrolls_tmp[index]['puPlus2Texts'][index_key] = this.buildWageFormula(
        user_payrolls_tmp[index]['puPlus2WageTexts'][index_key],
        user_payrolls_tmp[index]['puPlus2AmountTexts'][index_key]
      );
      break;
    }
    case 'puPlus2AmountTexts': {
      user_payrolls_tmp[index]['puPlus2AmountTexts'][index_key] = value;
      user_payrolls_tmp[index]['puPlus2Texts'][index_key] = this.buildWageFormula(
        user_payrolls_tmp[index]['puPlus2WageTexts'][index_key],
        user_payrolls_tmp[index]['puPlus2AmountTexts'][index_key]
      );
      break;
    }
    default:
      user_payrolls_tmp[index][key] = value;
    }

    if (key === 'puPlus1Wage' || key === 'puPlus1Amount') {
      user_payrolls_tmp[index]['puPlus1s'] = this.buildWageFormula(
        user_payrolls_tmp[index]['puPlus1Wage'],
        user_payrolls_tmp[index]['puPlus1Amount']
      );
      user_payrolls_tmp[index]['puPlus1'] = calculatePlusFromPlusS(user_payrolls_tmp[index]['puPlus1s']);
    }

    if (key === 'puPlus0Wage' || key === 'puPlus0Amount') {
      user_payrolls_tmp[index]['puPlus0s'] = this.buildWageFormula(
        user_payrolls_tmp[index]['puPlus0Wage'],
        user_payrolls_tmp[index]['puPlus0Amount']
      );
      user_payrolls_tmp[index]['puPlus0'] = calculatePlusFromPlusS(user_payrolls_tmp[index]['puPlus0s']);
    }

    if (key === 'puPlus3Wage' || key === 'puPlus3Amount') {
      user_payrolls_tmp[index]['puPlus3s'] = this.buildWageFormula(
        user_payrolls_tmp[index]['puPlus3Wage'],
        user_payrolls_tmp[index]['puPlus3Amount']
      );
      user_payrolls_tmp[index]['puPlus3'] = calculatePlusFromPlusS(user_payrolls_tmp[index]['puPlus3s']);
    }

    this.setValueChanged(findChanges(user_payrolls[index].uID, user_payrolls_tmp[index], user_payrolls[index]));

    // Calculate paid_leave_remaining when paid leave fields change
    if (['paid_leave_carry_over', 'paid_leave_granted', 'paid_leave_used'].includes(key)) {
      const carryOver = parseFloat(user_payrolls_tmp[index]['paid_leave_carry_over']) || 0;
      const granted = parseFloat(user_payrolls_tmp[index]['paid_leave_granted']) || 0;
      const used = parseFloat(user_payrolls_tmp[index]['paid_leave_used']) || 0;

      user_payrolls_tmp[index]['paid_leave_remaining'] = carryOver + granted - used;
    }

    this.setState({
      user_payrolls: [...user_payrolls_tmp]
    }, () =>{
      if(!['work_days', 'work_hours', 'work_overtime_hours', 'work_night_hours', 'work_holiday_hours',
        'paid_leave_carry_over', 'paid_leave_granted', 'paid_leave_used'].includes(key)) {
        this.triggerCallApi(index, user_payrolls_tmp[index].uID);
      }
    });
  };

  triggerCallApi = (index, userID) => {
    const {
      company,
      paramID,
      manual_mode
    } = this.props;

    const user_payrolls = this.formatPayrollTimes(this.state.user_payrolls);

    if(!manual_mode) {
      axios.post(`/companies/${company.cID}/payrolls/${paramID}/users/${userID}/auto_calc`, user_payrolls[index])
        .then(({
          data
        }) => {
          this.setValueChanged(findChanges(user_payrolls[index].uID, data.user_payroll, user_payrolls[index]));
          this.updatePayrollAutomaticCalculate(data.user_payroll, index);
          this.toggleMessage(null, 'success');
        }).catch((error) => {
          const errorMessage = error.response?.data?.error || error.message;
          this.toggleMessage(errorMessage, 'error');
        });
    }
  };

  autoCalcUserPayroll = (idx = 0, rtaxChangedUsers = []) => {
    const {
      company,
      paramID,
      manual_mode,
    } = this.props;

    const {
      payroll,
      user_payrolls,
      isTimeFormat
    } = this.state;

    let payroll_params = {
      ...payroll,
      ...this.denseItemTexts(payroll),
      user_payrolls_attributes: user_payrolls
    };

    payroll_params = {
      ...payroll_params,
      manual: manual_mode ? 'manual' : 'auto',
      time_format: isTimeFormat ? 'time' : 'number'
    };

    const usersToBeCalculated = this.autoCalcUserPayrolls();

    if(idx < usersToBeCalculated.length && !manual_mode) {
      axios.post(`/companies/${company.cID}/payrolls/${paramID}/users/${usersToBeCalculated[idx]['uID']}/auto_calc_and_save`, usersToBeCalculated[idx]).then(({
        data
      }) => {
        if(data.rtax_changed) {
          rtaxChangedUsers.push(data.user_payroll.uID);
        }

        this.setState({
          savingProgress: idx + 1,
          showProgressPopup: true,
        }, () => this.autoCalcUserPayroll(idx + 1, rtaxChangedUsers));
      }).catch((error) => {
        const errorMessage = error.response?.data?.error || error.message;
        this.setState({
          saving: false,
          showProgressPopup: false
        });
        this.toggleMessage(errorMessage, 'error');
      });
    }
    else{
      this.setState({touched: []});
      axios.put(`/companies/${company.cID}/payrolls/${paramID}/`, payroll_params).then(({
        data
      }) => {
        if (data.errors?.length) {
          this.setState({ saving: false });
          this.toggleMessage(data.errors.join(' '), 'error');
          return;
        }

        const ids = rtaxChangedUsers.join(', ');
        const pay_year= payroll['payDate'].split('-')[0];
        const pay_month = payroll['payDate'].split('-')[1];
        const baseUrl = `${location.protocol}//${location.host}/companies/${payroll['cID']}`;
        const year = pay_month < 6 ? pay_year - 1 : pay_year;
        const redirect_url = `${baseUrl}/rtaxes/${year}?uID=${ids}`;
        const dashboard_url = `${baseUrl}/payrolls/${payroll.payroll_id}`;

        if (rtaxChangedUsers.length > 0 && pay_month !== '6' && this.props.payroll.payKubun === 'salary') {
          this.setState({saving: false});
          this.openModal(redirect_url);
        } else {
          window.location.replace(dashboard_url);
        }
      }).catch((err) => {
        this.setState({ saving: false });
        this.toggleMessage(err.response?.data?.error || err.message, 'error');
      });
    }
  };

  updatePayrollAutomaticCalculate = (res, index) => {
    const self = this;
    const {
      user_payrolls
    } = this.state;
    const user_payrolls_tmp = [...user_payrolls];
    const keys = Object.keys(res);

    keys.forEach((e, idx) => {
      user_payrolls_tmp[index][e] = res[e];
      if (idx + 1 == keys.length) {
        self.setState({
          user_payrolls: user_payrolls_tmp
        });
      }
    });
  };

  savePayroll = () => {
    const user_payrolls = this.formatPayrollTimes(this.state.user_payrolls);

    this.setState({ user_payrolls: user_payrolls, saving: true }, () => {
      this.autoCalcUserPayroll();
    });
  };

  denseItemTexts = (record) => ({
    puPlus2Texts: Array.from(record.puPlus2Texts || [], (text) => text ?? ''),
    puMinus6Texts: Array.from(record.puMinus6Texts || [], (text) => text ?? ''),
  });

  updateMemo = (value) => {
    this.setState({
      payroll: {
        ...this.state.payroll,
        pMemo: value
      }
    });
  };

  formatPayrollTimes = (userPayrolls) => {
    return userPayrolls.map(payroll => ({
      ...payroll,
      ...this.denseItemTexts(payroll),
      work_hours: timeToFloat(payroll.work_hours),
      work_overtime_hours: timeToFloat(payroll.work_overtime_hours),
      work_night_hours: timeToFloat(payroll.work_night_hours),
      work_holiday_hours: timeToFloat(payroll.work_holiday_hours),
    }));
  };

  // #2250: 全角(IME)入力を許容し、確定時に子コンポーネント側で半角へ自動変換 +
  // 不許可文字を削除するようにしたため、「半角で入力してください」の警告トーストは
  // 廃止した。子は onImeWarning を呼ばなくなったので本メソッドは no-op で残す
  // (子への prop 受け渡しを一括削除しないための互換用)。
  handleImeWarning = () => {};

  handleInputChange = (event, index, inputType, idx = null) => {
    // Ignore intermediate events fired while the IME is composing. Converting
    // full-width to half-width and writing it back into the controlled input
    // mid-composition makes the IME re-insert its buffer and duplicates the
    // characters. The browser fires a final non-composing event after
    // compositionend, which is processed normally.
    if (event.nativeEvent && event.nativeEvent.isComposing) {
      return;
    }

    // 変換確定後の通常イベント。次の IME 入力で再度警告できるようフラグを戻す。
    this._imeToastShown = false;

    this.automaticCalculatePayroll(event.target.value, index, inputType, idx);
  };

  handleGridKeyDown = (e) => {
    if (e.key !== 'Enter' || e.nativeEvent.isComposing || e.keyCode === 229) return;

    const input = e.target;
    if (input.tagName !== 'INPUT') return;

    const td = input.closest('td.salary');
    const tr = td && td.parentElement;
    const rows = Array.from(e.currentTarget.tBodies[0].rows);
    const rowIndex = rows.indexOf(tr);
    if (rowIndex < 0) return;

    const column = Array.from(tr.querySelectorAll(':scope > td.salary')).indexOf(td);
    const step = e.shiftKey ? -1 : 1;

    for (let i = rowIndex + step; i >= 0 && i < rows.length; i += step) {
      const cell = rows[i].querySelectorAll(':scope > td.salary')[column];
      const target = cell && cell.querySelector('input:not([disabled]):not([readonly]):not([type="hidden"])');
      if (target && target.offsetParent !== null) {
        e.preventDefault();
        target.focus();
        target.select();
        return;
      }
    }
  };

  handleInputFocus = (_event, userID, inputType) => {
    this.toggleMemo(userID, inputType);
  };

  // MEMO: To auto calc all user payrolls
  //  When payrolls is manual mode and opened edit page with auto mode
  autoCalcUserPayrolls = () => {
    const { user_payrolls, touched, manual_mode } = this.state;

    if (this.props.payroll.manual == 'manual' && !manual_mode)  return user_payrolls;

    return user_payrolls.filter(up => touched.map(t => t.id).includes(up.uID));
  };

  render() {
    const styles = {
      header: {
        backgroundColor: '#333333'
      },
      body: {
        marginTop: '47px'
      },
      headerTable: {
        top: '47px'
      }
    };

    const {
      company,
      unemployment_insurances,
      welfare_pensions,
      social_insurances,
      puKubuns,
      puTaxTables,
      hyojunHoshus,
      image_timer_url,
      image_edit_url,
    } = this.props;
    const {
      user_payrolls,
      waggerTimerDisplay,
      puPlusEditDisplay,
      puMinusEditDisplay,
      puPlus1Display,
      puPlus0Display,
      puPlus3Display,
      alertPopup,
      memoPopup,
      touched,
      isModalOpen,
      redirect_url,
      manual_mode,
      saving,
      savingProgress,
      payroll,
      nameLengthErrors,
      deductionWarnings,
    } = this.state;

    const hasNameLengthErrors = nameLengthErrors.plus.length > 0 || nameLengthErrors.minus.length > 0;
    const missingNames = payroll ? this.missingNames() : { plus: [], minus: [] };
    const hasMissingNames = missingNames.plus.length > 0 || missingNames.minus.length > 0;
    const is_admin = true; // MEMO: Restricted when admin test
    const waggerTimeShowing = waggerTimerDisplay.filter((e, idx) => valuePresent(payroll.puPlus2Texts[idx]) && e === true).length;
    const wageTimerRowSpan = waggerTimeShowing > 0 ? (waggerTimeShowing * 2) + payroll.pPayPlusCount : payroll.pPayPlusCount;
    const puPlus0RowSpan = (puPlus0Display ? 6 : 4) + (payroll.isMonthly ? 0 : -1);
    const puPlus3RowSpan = puPlus3Display ? 2 : 0;
    const puPlus1RowSpan = puPlus1Display ? 3 : 1;

    const rowSpanPaymentHeader = payroll ? wageTimerRowSpan + puPlus0RowSpan + puPlus3RowSpan + puPlus1RowSpan : null;

    const changedUsers = this.autoCalcUserPayrolls();

    if (payroll) {
      return (
        <>
          <AlertMessage alertPopup={alertPopup} />
          {hasMissingNames &&
            <div className="alert-component alert-error name-missing-alert" role="alert">
              <h4>項目名が入っていません</h4>
              金額が入っている項目には項目名を入れてください
            </div>
          }
          <Memo memoPopup={memoPopup} />
          {(saving &&
          /* #2134: 保存進捗をトースト + 進捗バーで表す。
             「保存しています…」「N/M 件の保存完了」の文言は不変(spec 文言契約)。 */
          <div className="loader-overlay save-toast-overlay" role="status">
            <div className="loading-container save-toast">
              <div className="loading-message save-toast-msg">
                <span >保存しています…</span>
                { changedUsers && changedUsers.length > 0 &&
                <span className="save-toast-count"> {`${savingProgress}/${changedUsers.length} 件の保存完了`} </span>
                }
              </div>
              { changedUsers && changedUsers.length > 0
                ? <div className="save-toast-bar">
                  <div
                    className="save-toast-bar-fill"
                    style={{ width: `${Math.round((savingProgress / changedUsers.length) * 100)}%` }}
                  />
                </div>
                : <div className="loader" />
              }
            </div>
          </div>
          )}
          {/* #2129: 給与編集リデザインは ?design=new のときだけ適用する。
              既定 (legacy) は従来 DOM のまま (spec が叩く既定構造を不変に保つ)。 */}
          <div className="d-flex flex-column company-payroll payroll-edit-redesign">
            {/* #2130: ツールバー (.ebar)。button.btn-warning / テキスト「保存する」/
                onClick / .manual-header の契約は spec のため不変。 */}
            <div className="head ebar d-flex flex-row justify-content-between align-content-stretch fixed-top px-2 py-1" style={styles.header}>
              <div className="ebar-title">
                { payroll.payKubun === 'bonus'
                  ? <input className="payName" name="payroll[payroll_name]" onChange={(e) => this.handlePayrollChange(e.target.value, 'payName')} size="30" type="text" value={payroll.name} />
                  : <h3 className="d-inline-block m-0" style={{ color: '#fff' }}>{payroll.name}</h3>
                }
              </div>
              <div className="ebar-actions text-end pt-1">
                { touched.length > 0 &&
                  <span className="ebar-unsaved" role="status">未保存の変更があります</span>
                }
                <button className="btn btn-warning span2 mx-3"
                  disabled={hasNameLengthErrors || hasMissingNames}
                  onClick={this.savePayroll}
                >
                  保存する
                </button>
                <a className="btn btn-link text-white mx-3"
                  href={`/companies/${payroll.cID}/payrolls/${payroll.payroll_id}`}
                >
                  戻る
                </a>
              </div>
            </div>
            { manual_mode &&
            <div className="manual-header"> マニュアルモードで入力しています。自動計算はされません </div>
            }
            <div className="body-payroll">
              <table className={`editable payroll ${manual_mode ? '' : 'manual-mode-margin'}`} onKeyDown={this.handleGridKeyDown}>
                {/* #2359: 新デザインは table-layout:fixed(paybook.sass)。先頭行の
                    コーナー(th0)が colspan=2 のため縦見出し列(労働時間/支給/控除)の
                    幅が先頭行だけでは決まらず、min-width:100px フロアに巻き込まれて
                    ~100px に膨らむ。<col> で列幅を明示して固定する。col.th1/th2 は
                    legacy の width(帯列 39px = 1文字+α・項目名列 120px)を継承する。
                    legacy DOM(?design 既定)には出さないので spec 契約は不変。 */}
                <colgroup>
                  <col className="th1" />
                  <col className="th2" />
                </colgroup>
                <thead>
                  <tr>
                    <th className="th0" colSpan="2" id="itemName no-min-width" rowSpan="2"><span>項目名</span></th>
                    {user_payrolls.map((_payroll, index) => (
                      <th className="staff w9" key={index}><span>{index + 1}</span></th>
                    ))}
                  </tr>
                  <tr>
                    {user_payrolls.map((user_payroll, index) => {
                      return (
                        <th className="staff w9 usernames" data-bs-placement="bottom" data-bs-toggle="tooltip" key={index} title={user_payroll.user.uName}>
                          <span className="w7 nowrap">{user_payroll.user.uName}</span>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {
                    company.use_working_hours &&
                    <tr className="position-absolute" id="time-toggle-container">
                      <th className="text-center border-right-0 bg-transparent">
                        <button
                          className="btn btn-secondary h-50 w-75 p-0"
                          onClick={() => this.setState({ isTimeFormat: !this.state.isTimeFormat })}
                        >
                          <span className="small">
                            時間形式
                            <br />
                            { this.state.isTimeFormat ? '(時間/HH:MM)' : '(数字/1.0)' }
                          </span>
                        </button>
                      </th>
                    </tr>
                  }
                  {company.use_working_hours &&
                  <>
                    <tr>
                      <th className="item th1 grp-band grp-labor no-min-width" rowSpan={5}>
                        <span>労<br />働<br />時<br />間</span>
                      </th>
                      <NumberInputRow
                        inputType="work_days"
                        onImeWarning={this.handleImeWarning}
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="労働日数"
                        userPayrolls={user_payrolls}
                        onClearRow={() => this.clearData('work_days')}
                      />
                    </tr>
                    <tr>
                      <NumberOrTimeInputRow
                        inputType="work_hours"
                        onImeWarning={this.handleImeWarning}
                        isTimeFormat={this.state.isTimeFormat}
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="労働時間"
                        userPayrolls={user_payrolls}
                        onClearRow={() => this.clearData('work_hours')}
                      />
                    </tr>
                    <tr>
                      <NumberOrTimeInputRow
                        inputType="work_overtime_hours"
                        onImeWarning={this.handleImeWarning}
                        isTimeFormat={this.state.isTimeFormat}
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="時間外労働時間"
                        userPayrolls={user_payrolls}
                        onClearRow={() => this.clearData('work_overtime_hours')}
                      />
                    </tr>
                    <tr>
                      <NumberOrTimeInputRow
                        inputType="work_night_hours"
                        onImeWarning={this.handleImeWarning}
                        isTimeFormat={this.state.isTimeFormat}
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="深夜労働時間"
                        userPayrolls={user_payrolls}
                        onClearRow={() => this.clearData('work_night_hours')}
                      />
                    </tr>
                    <tr>
                      <NumberOrTimeInputRow
                        inputType="work_holiday_hours"
                        onImeWarning={this.handleImeWarning}
                        isTimeFormat={this.state.isTimeFormat}
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="休日労働時間"
                        userPayrolls={user_payrolls}
                        onClearRow={() => this.clearData('work_holiday_hours')}
                      />
                    </tr>
                  </>
                  }
                  <tr>
                    <th className="item th1 plus grp-band grp-give no-min-width" rowSpan={rowSpanPaymentHeader}>
                      <span>支<br /> <br />給</span>
                    </th>
                  </tr>
                  {payroll.isMonthly && (
                    <PlusInput
                      clearAmount={() => this.clearData('puPlus0Amount')}
                      imageTimerUrl={image_timer_url}
                      inputType="puPlus0"
                      onAmountChange={this.handleInputChange}
                      onAmountFocus={this.handleInputFocus}
                      onImeWarning={this.handleImeWarning}
                      onPlusChange={this.handleInputChange}
                      onPlusFocus={this.handleInputFocus}
                      onWageChange={this.handleInputChange}
                      onWageFocus={this.handleInputFocus}
                      puPlusDisplay={puPlus0Display}
                      setValueChanged={this.setValueChanged}
                      title="役員報酬"
                      toggleTimer={() => this.setState(s => ({ puPlus0Display: !s.puPlus0Display })) }
                      touched={touched}
                      useTimeFormat={is_admin}
                      userPayrolls={user_payrolls}
                    />
                  )}
                  <PlusInput
                    clearAmount={() => this.clearData('puPlus1Amount')}
                    imageTimerUrl={image_timer_url}
                    inputType="puPlus1"
                    onAmountChange={this.handleInputChange}
                    onAmountFocus={this.handleInputFocus}
                    onImeWarning={this.handleImeWarning}
                    onPlusChange={this.handleInputChange}
                    onPlusFocus={this.handleInputFocus}
                    onWageChange={this.handleInputChange}
                    onWageFocus={this.handleInputFocus}
                    puPlusDisplay={puPlus1Display}
                    setValueChanged={this.setValueChanged}
                    title={payroll.baseName}
                    toggleTimer={() => this.setState(s => ({ puPlus1Display: !s.puPlus1Display })) }
                    touched={touched}
                    useTimeFormat={is_admin}
                    userPayrolls={user_payrolls}
                  />
                  {this.props.payroll && payroll.puPlus2Texts.map((text, idx) =>
                    <Plus2Input
                      clearAmount={() => this.clearData('puPlus2AmountTexts', idx)}
                      clearRow={() => this.clearData('puPlus2Texts', idx)}
                      handlePayrollChange={e => this.handlePayrollChange(e.target.value, 'puPlus2Texts', idx)}
                      hasDeductionWarning={deductionWarnings.includes(idx)}
                      hasMissingName={missingNames.plus.includes(idx)}
                      hasNameError={nameLengthErrors.plus.includes(idx)}
                      idx={idx}
                      imageEditUrl={image_edit_url}
                      imageTimerUrl={image_timer_url}
                      key={idx}
                      onAmountChange={this.handleInputChange}
                      onAmountFocus={this.handleInputFocus}
                      onPlusChange={this.handleInputChange}
                      onPlusFocus={this.handleInputFocus}
                      onWageChange={this.handleInputChange}
                      onWageFocus={this.handleInputFocus}
                      puPlusEditDisplay={puPlusEditDisplay[idx]}
                      setValueChanged={this.setValueChanged}
                      text={text}
                      textExisted={valuePresent(this.props.payroll.puPlus2Texts[idx])}
                      title={payroll.baseName}
                      toggleEdit={() => this.toggleDisplay('puPlusEditDisplay', idx)}
                      toggleTimer={() => this.toggleDisplay('waggerTimerDisplay', idx)}
                      touched={touched}
                      useTimeFormat={is_admin}
                      userPayrolls={user_payrolls}
                      waggerTimerDisplay={waggerTimerDisplay[idx]}
                    />
                  )}
                  <PlusInput
                    clearAmount={() => this.clearData('puPlus3Amount')}
                    imageTimerUrl={image_timer_url}
                    inputType="puPlus3"
                    onAmountChange={this.handleInputChange}
                    onAmountFocus={this.handleInputFocus}
                    onImeWarning={this.handleImeWarning}
                    onPlusChange={this.handleInputChange}
                    onPlusFocus={this.handleInputFocus}
                    onWageChange={this.handleInputChange}
                    onWageFocus={this.handleInputFocus}
                    puPlusDisplay={puPlus3Display}
                    setValueChanged={this.setValueChanged}
                    title="非課税交通費"
                    toggleTimer={() => this.setState(s => ({ puPlus3Display: !s.puPlus3Display })) }
                    useTimeFormat={is_admin}
                    userPayrolls={user_payrolls}
                  />
                  <tr className="total">
                    <FomulaInput
                      delimited
                      inputType="puPlusTotal"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="支給合計"
                      touched={touched}
                      userPayrolls={user_payrolls}
                    />
                  </tr>
                  <tr>
                    <th className="item th1 grp-band grp-take no-min-width" rowSpan={payroll.pPayMinusCount + 6 + (this.props.use_childcare_support_fee ? 1 : 0) + (this.props.tax2024 ? 1 : 0)}>
                      <span>控<br /><br />除</span>
                    </th>
                    <FomulaInput
                      disabledCondition={{'puShakaiHoken': 'social_insurance_manual'}}
                      inputType="puMinus1"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="健康保険料"
                      touched={touched}
                      userPayrolls={user_payrolls}
                      zeroAsNull
                    />
                  </tr>
                  <tr>
                    <FomulaInput
                      disabledCondition={{'puShakaiHoken': 'social_insurance_manual'}}
                      inputType="puMinus3"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="介護保険料"
                      touched={touched}
                      userPayrolls={user_payrolls}
                      zeroAsNull
                    />
                  </tr>
                  {this.props.use_childcare_support_fee &&
                  <tr>
                    <FomulaInput
                      disabledCondition={{'puShakaiHoken': 'social_insurance_manual'}}
                      inputType="childcare_support_fee"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="子育て支援金"
                      touched={touched}
                      userPayrolls={user_payrolls}
                      zeroAsNull
                    />
                  </tr>
                  }
                  <tr>
                    <FomulaInput
                      disabledCondition={{'puNenkinHoken': 'welfare_pension_manual'}}
                      inputType="puMinus2"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="厚生年金保険"
                      touched={touched}
                      userPayrolls={user_payrolls}
                      zeroAsNull
                    />
                  </tr>
                  <tr>
                    <FomulaInput
                      disabledCondition={{'puKoyoHoken': 'unemployment_insurance_manual'}}
                      inputType="puMinus4"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="雇用保険料"
                      touched={touched}
                      userPayrolls={user_payrolls}
                      zeroAsNull
                    />
                  </tr>
                  <tr>
                    <FomulaInput
                      inputType="puMinus5"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="所得税"
                      touched={touched}
                      userPayrolls={user_payrolls}
                    />
                  </tr>
                  {this.props.tax2024 && (
                    <tr>
                      <NumberInputRow
                        disabled
                        inputType="tax2024_tax_reduction"
                        manualMode={manual_mode}
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="定額減税"
                        touched={touched}
                        userPayrolls={user_payrolls}
                      />
                    </tr>
                  )}
                  {this.props.payroll && payroll.puMinus6Texts.map((text, idx) =>
                    <Minus6Input
                      clearRow={() => this.clearData('puMinus6Texts', idx)}
                      handlePayrollChange={e => this.handlePayrollChange(e.target.value, 'puMinus6Texts', idx)}
                      hasMissingName={missingNames.minus.includes(idx)}
                      hasNameError={nameLengthErrors.minus.includes(idx)}
                      idx={idx}
                      imageEditUrl={image_edit_url}
                      key={idx}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      puMinusEditDisplay={puMinusEditDisplay}
                      text={text}
                      textExisted={valuePresent(this.props.payroll.puMinus6Texts[idx])}
                      toggleDisplay={() => this.toggleDisplay('puMinusEditDisplay', idx)}
                      touched={touched}
                      userPayrolls={user_payrolls}
                    />
                  )}
                  <tr className="total">
                    <FomulaInput
                      delimited
                      inputType="puMinusTotal"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="控除合計"
                      touched={touched}
                      userPayrolls={user_payrolls}
                      zeroAsNull
                    />
                  </tr>
                  <tr className="total">
                    <FomulaInput
                      clz="th1"
                      delimited
                      inputType="puPrice"
                      manualMode={manual_mode}
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      title="差引支給合計"
                      touched={touched}
                      userPayrolls={user_payrolls}
                    />
                  </tr>
                  {company.use_paid_leave &&
                  <>
                    <tr>
                      <th className="item th1 grp-band grp-leave no-min-width" rowSpan={4}>
                        <span>有<br />給<br />休<br />暇</span>
                      </th>
                      <NumberInputRow
                        inputType="paid_leave_carry_over"
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="繰越日数"
                        userPayrolls={user_payrolls}
                      />
                    </tr>
                    <tr>
                      <NumberInputRow
                        inputType="paid_leave_granted"
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="付与日数"
                        userPayrolls={user_payrolls}
                      />
                    </tr>
                    <tr>
                      <NumberInputRow
                        inputType="paid_leave_used"
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="使用日数"
                        userPayrolls={user_payrolls}
                      />
                    </tr>
                    <tr>
                      <NumberInputRow
                        disabled
                        inputType="paid_leave_remaining"
                        onInputChange={this.handleInputChange}
                        onInputFocus={this.handleInputFocus}
                        title="残日数"
                        userPayrolls={user_payrolls}
                      />
                    </tr>
                  </>
                  }
                  <tr>
                    {/* #2129: 設定セクションにも縦書き帯(設定)を付けて他セクションと
                        揃える。rowspan は条件行(tax2024 +2 / !manual_mode 保険3行)を
                        加味して算出。帯を出すぶん設定各行は settingsBand で
                        項目名を th2 単一列にする。 */}
                    <th className="item th1 grp-band grp-set no-min-width" rowSpan={6 + (this.props.tax2024 ? 2 : 0) + (manual_mode ? 0 : 3)}>
                      <span>設<br />定</span>
                    </th>
                    <NumberInputRow
                      clz="th2"
                      inputType="puFamily"
                      onInputChange={this.handleInputChange}
                      onInputFocus={this.handleInputFocus}
                      settingsBand
                      title="扶養人数"
                      userPayrolls={user_payrolls}
                    />
                  </tr>
                  <SelectionInput
                    inputType="puTaxTable"
                    onSelectChange={this.handleInputChange}
                    onSelectFocus={this.handleInputFocus}
                    optionAttributes={puTaxTables}
                    settingsBand
                    title="税額表"
                    userPayrolls={user_payrolls}
                  />
                  {this.props.tax2024 && (
                    <>
                      <tr>
                        <NumberInputRow
                          clz="th2"
                          disabled
                          inputType="tax2024_number_of_family_members"
                          manualMode={manual_mode}
                          onInputChange={this.handleInputChange}
                          onInputFocus={this.handleInputFocus}
                          settingsBand
                          title="減税対象者数"
                          touched={touched}
                          userPayrolls={user_payrolls}
                        />
                      </tr>
                      <tr>
                        <NumberInputRow
                          clz="th2"
                          disabled
                          inputType="tax2024_remaining_amount"
                          manualMode={manual_mode}
                          onInputChange={this.handleInputChange}
                          onInputFocus={this.handleInputFocus}
                          settingsBand
                          title="減税次月繰越"
                          touched={touched}
                          userPayrolls={user_payrolls}
                        />
                      </tr>
                    </>
                  )}
                  <SelectionInput
                    inputType="puKubun"
                    onSelectChange={this.handleInputChange}
                    onSelectFocus={this.handleInputFocus}
                    optionAttributes={puKubuns}
                    settingsBand
                    title="従業員区分"
                    userPayrolls={user_payrolls}
                  />
                  { !manual_mode &&
                  <>
                    <SelectionInput
                      inputType="puShakaiHoken"
                      onSelectChange={this.handleInputChange}
                      onSelectFocus={this.handleInputFocus}
                      optionAttributes={social_insurances}
                      settingsBand
                      title={this.props.use_childcare_support_fee ? "健康/介護/子育て" : "健康/介護保険"}
                      userPayrolls={user_payrolls}
                    />
                    <SelectionInput
                      inputType="puNenkinHoken"
                      onSelectChange={this.handleInputChange}
                      onSelectFocus={this.handleInputFocus}
                      optionAttributes={welfare_pensions}
                      settingsBand
                      title="厚生年金保険料"
                      userPayrolls={user_payrolls}
                    />
                    <SelectionInput
                      inputType="puKoyoHoken"
                      onSelectChange={this.handleInputChange}
                      onSelectFocus={this.handleInputFocus}
                      optionAttributes={unemployment_insurances}
                      settingsBand
                      title="雇用保険料"
                      userPayrolls={user_payrolls}
                    />
                  </>
                  }
                  <HyojunhoshuInput
                    onSelectChange={this.handleInputChange}
                    onSelectFocus={this.handleInputFocus}
                    optionAttributes={hyojunHoshus}
                    settingsBand
                    userPayrolls={user_payrolls}
                  />
                  <tr className="remove-btn">
                    {/* 設定帯の最終行。項目名列に「操作」を出す(帯は上の扶養人数行の
                        rowspan がここまで覆う)。 */}
                    <th className="item th2 no-min-width"><span>操作</span></th>
                    {user_payrolls.map((user_payroll, index) => {
                      return (
                        <td className={`w9 text-center remove-userpayroll-${user_payroll.uID}`} key={index}>
                          <button className="btn btn-dark btn-sm m-1" onClick={() => this.removeUserPayroll(user_payroll.user)}>削除</button>
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
            {/* #2133/#2129: メモ下部ドック。.body-payroll の外・フレックス列の
                最下段に置き、スクロールと独立して下端固定する。
                クリックでドロワー (下の兄弟 .memo-drawer) を開閉。 */}
            <div className="memo-dock">
              <button
                className="memo-tab"
                type="button"
                onClick={() => this.setState({ memoDrawerOpen: !this.state.memoDrawerOpen })}
              >
                <svg aria-hidden="true" fill="none" height="14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="14">
                  <path d="M5 3h11l4 4v14H5zM16 3v4h4M8 12h8M8 16h6" />
                </svg>
                メモ : 次回の給与への引き継ぎ事項など
              </button>
              <span className="memo-dock-foot">次回の給与作成時に確認したいことなどを記録できます</span>
            </div>
          </div>

          <>
            <div
              className={`memo-scrim ${this.state.memoDrawerOpen ? 'show' : ''}`}
              onClick={() => this.setState({ memoDrawerOpen: false })}
            />
            <div className={`memo-drawer ${this.state.memoDrawerOpen ? 'open' : ''}`}>
              <div className="memo-drawer-head">
                <h3 className="m-0">メモ : 次回の給与への引き継ぎ事項など</h3>
                <button
                  className="memo-drawer-close"
                  type="button"
                  aria-label="閉じる"
                  onClick={() => this.setState({ memoDrawerOpen: false })}
                >
                  ×
                </button>
              </div>
              <div className="memo-drawer-body">
                <textarea
                  data-uid={payroll.pID}
                  defaultValue={payroll.pMemo || ''}
                  name="payment[memo]"
                  onBlur={(e) => this.updateMemo(e.target.value)} rows="6"
                />
              </div>
            </div>
          </>
          <Modal
            ariaHideApp={false}
            className="rtax-modal"
            contentLabel="Modal"
            isOpen={isModalOpen}
            onRequestClose={(e) => this.closeModal()}
          >
            <h2>住民税の変更がありました</h2>
            <p>来月以降の住民税も登録しておくと、来月以降の給与作成時に自動反映されます</p>
            <a href={redirect_url}>住民税を登録する</a>
            <div className="modal-footer">
              <button className="button btn btn-secondary close-button" onClick={(e) => this.closeModal()}>閉じる</button>
            </div>
          </Modal>
        </>
      );
    } else {
      return (<div />);
    }
  }
}

CompanyPayrollsTable.propTypes = {
  company: PropTypes.object,
  payroll: PropTypes.object,
  paramID: PropTypes.string,
  manual_mode: PropTypes.string,
  isMonthly: PropTypes.bool,
  isPaidOrTrialPlan: PropTypes.bool,
  maxAllowances: PropTypes.number,
  maxDeductions: PropTypes.number,
  baseName: PropTypes.string,
  puPlus2Texts: PropTypes.string,
  puMinus6Texts: PropTypes.string,
  unemployment_insurances: PropTypes.array,
  welfare_pensions: PropTypes.array,
  social_insurances: PropTypes.array,
  puKubuns: PropTypes.array,
  puTaxTables: PropTypes.array,
  hyojunHoshus: PropTypes.array,
  image_timer_url: PropTypes.string,
  image_edit_url: PropTypes.string,
  isPaidPlan: PropTypes.bool,
  tax2024: PropTypes.bool,
  time_format: PropTypes.bool,
  is_admin: PropTypes.bool,
};

export default CompanyPayrollsTable;
